/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PaymentStatusEnum {

    Unpaid = 'unpaid',

    PartiallyPaid = 'partiallyPaid',

    Paid = 'paid',

    PartiallyRefunded = 'partiallyRefunded',

    Refunded = 'refunded'
}

